import { render, staticRenderFns } from "./TaskUnitConfig.vue?vue&type=template&id=7bdf2ffa"
import script from "./TaskUnitConfig.vue?vue&type=script&lang=js"
export * from "./TaskUnitConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports